exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".subscription-order__header {\n  text-align: center;\n}\n.subscription-order__header.header--dates {\n  margin-bottom: 35px;\n}\n.subscription-order__address {\n  white-space: pre-line;\n}\n.address__header {\n  display: block;\n  font-weight: bold;\n}\n.subscription-order__footer {\n  border-top: 1px solid #f4f4f4;\n}", ""]);

// exports
